import api from './api.js';

export const cbtService = {
  // Get available CBT exams for the logged-in student
  getAvailableExams: () => api.get('/exams/cbt/available'),
  
  // Validate access to CBT exam
  validateAccess: (examId) => api.post('/exams/cbt/validate-access', { examId }),
  
  // Login to CBT exam
  loginToExam: (examId) => api.post(`/exams/cbt/${examId}/login`),
  
  // Get exam status (waiting or active)
  getExamStatus: (examId) => api.get(`/exams/cbt/${examId}/status`),
  
  // Start exam (transition from waiting to active)
  startExam: (examId) => api.post(`/exams/cbt/${examId}/start`),
  
  // Autosave answers
  autoSaveAnswers: (examId, answers, timeRemaining) => 
    api.post(`/exams/cbt/${examId}/autosave`, {
      answers,
      timeRemaining
    }),
  
  // Send heartbeat
  sendHeartbeat: (examId, isOnline = true) => 
    api.post(`/exams/cbt/${examId}/heartbeat`, { isOnline }),
  
  // Log violation
  logViolation: (examId, violationType, details = {}) => 
    api.post(`/exams/cbt/${examId}/violation`, {
      violationType,
      details
    }),
  
  // Submit exam
  submitExam: (examId, answers, isAutoSubmit = false) => 
    api.post(`/exams/cbt/${examId}/submit`, {
      answers,
      isAutoSubmit
    }),
  
  // Sync offline data
  syncOfflineData: (examId, offlineData) => 
    api.post(`/exams/cbt/${examId}/sync-offline`, offlineData),

  // Get exam details
  getExamDetails: (examId) => api.get(`/exams/cbt/${examId}/details`),

  // Get exam questions
  getExamQuestions: (examId) => api.get(`/exams/cbt/${examId}/questions`),

  // Get exam result
  getExamResult: (examId) => api.get(`/exams/cbt/${examId}/result`)
};

